import { render, staticRenderFns } from "./complaintWorkInfo.vue?vue&type=template&id=9c3a436c&"
import script from "./complaintWorkInfo.vue?vue&type=script&lang=js&"
export * from "./complaintWorkInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports